import React from 'react';
import { hashHistory   } from 'react-router' //, hashHistory 
import Home from 'material-ui/svg-icons/action/home';
import Search from 'material-ui/svg-icons/action/search';
import Messaging from 'material-ui/svg-icons/communication/message';
import Account from 'material-ui/svg-icons/social/person';
import {Tabs, Tab} from 'material-ui/Tabs';
import Badge from 'material-ui/Badge';
import { connect } from 'react-redux'

//https://stackoverflow.com/questions/31839175/styling-reacts-material-ui-tabs

class TabStrip extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            value: "0",
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        var elTextBox = document.getElementById("tab-strip");
        if(elTextBox) {
            elTextBox.style.position = "fixed";
            elTextBox.style.bottom = "0px"; 
        }
    }

    handleChange = (value) => {

        this.setState({value: value});

        var self = this;

        window.setTimeout(function(value){ 
            
            var v = self.state.value;

            switch(v)
            {
                case 1:
                    hashHistory.push("/home");
                    break;
                case 2:
                    hashHistory.push("/search");
                    break;
                case 3:
                    hashHistory.push("/messages");
                    break;
                case 4:
                    hashHistory.push("/account");
                    break;
                default:
                    hashHistory.push("/home");
                    break;
            }

            if(self.props.onTabChange) {
                self.props.onTabChange(v);
            }
        }, 500);
        
      
    };

    getLabel = (key) => {

        var retVal = null;
        if(this.props.member.Tabs){
            var config = this.props.member.Tabs.filter((c) => {
                return c.TabID === key;
            })
            
            if(config.length > 0){
                retVal = config[0].Text;
            }
        }
        
        if(!retVal){
            switch(key){
                case 1:
                    retVal = "Home"
                    break;
                case 2:
                    retVal = "Care"
                    break;
                case 3:
                    retVal = "Messages"
                    break;
                case 4:
                    retVal = "Account"
                    break;
            }
        }

        return retVal;
    }

    render() {


        return (
            <div id="tab-strip" className="tabStrip" >
                {this.props.member && (
                    <Tabs 
                        
                        inkBarStyle={{ display: 'none' }}  
                        value={this.props.activeTab}
                        onChange={this.handleChange}
                    >
                        <Tab label={this.getLabel(1)} value={1} icon={<Home />} />

                        {this.props.member.IsSearchModuleActive && (
                            <Tab label={this.getLabel(2)} value={2} icon={<Search />}/>
                        )}
                        
                        {this.props.member.IsTwoWayMessagingActive && this.props.messageCount > 0 && (
                            <Tab label={this.getLabel(3)} value={3} icon={<Badge
                                badgeContent={this.props.messageCount}
                                secondary={true}
                                badgeStyle={{top: 7, right: 7}}
                            >
                            </Badge>}/>
                        )}

                        {this.props.member.IsTwoWayMessagingActive && this.props.messageCount === 0 && (
                            <Tab label={this.getLabel(3)} value={3} icon={<Messaging />}/>
                        )}

                        <Tab label={this.getLabel(4)} value={4} icon={<Account />}/>
                    </Tabs>
                )}
            </div>
        )
    }
}



const mapDispatchToProps = (dispatch) => {
    return {
      
    }
  }
  
  const mapStateToProps = (state) => ({
      messageCount: state.thisApp.messaging.globalNewMessageCount,
      member: state.thisApp.auth.member
    //   isSearchModuleActive: state.thisApp.auth.member.IsSearchModuleActive,
    //   isTwoWayMessagingActive: state.thisApp.auth.member.IsTwoWayMessagingActive
  })
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(TabStrip)
  
  


// WEBPACK FOOTER //
// ./src/Components/TabStrip.js